import { Box, Typography } from '@mui/material';
import { Badge } from '../Logo/Badge';
import { SafeLinkWithFallback } from '../SafeLinkWithFallback';
import { RatingTooltip } from './components/RatingToolTip';
import { StarIcon } from './components/StarIcon';

type NwLogoHorizontalLayoutProps = {
  hideNwLogo?: boolean;
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
};

export const ShortHorizontalLayout = ({
  hideNwLogo = false,
  reviewLink,
  starRating,
  starRatingTooltip,
}: NwLogoHorizontalLayoutProps) => {
  return (
    <Box data-testid="rating-component" sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {!hideNwLogo && <Badge sx={{ height: 14, width: 14 }} />}
      {starRating && starRating > 0 ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <Typography
              variant="textBold"
              sx={{
                fontSize: 14,
                fontWeight: 700,
              }}
            >
              <SafeLinkWithFallback href={reviewLink} target="_blank">
                {starRating.toFixed(1)}
              </SafeLinkWithFallback>
            </Typography>
            <StarIcon color="#008254" additionalStyles={{ fontSize: 18 }} />
          </Box>
          {starRatingTooltip && (
            <Box sx={{ '& button': { display: 'flex' } }}>
              <RatingTooltip
                starRatingTooltip={starRatingTooltip}
                tooltipColor="neutral.dark"
                tooltipSize="16px"
              />
            </Box>
          )}
        </>
      ) : (
        <Typography variant="textSmall">Not yet rated</Typography>
      )}
    </Box>
  );
};
